import {
    GET_MUST_SELL_SKUS,
    GET_MUST_SELL_SKU,
    ADD_PRODUCT_GROUPS_TO_MUST_SELL,
    CREATE_MUST_SELL_SKU,
    DELETE_MUST_SELL_SKUS,
    REMOVE_PRODUCT_GROUPS_FROM_MUST_SELL,
    UPDATE_MUST_SELL_SKU,
    GET_MUST_SELL_SKUS_BY_IDS
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    mustSells: {},
    mustSell: {},
};

// REDUCER
export const MustSellReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MUST_SELL_SKUS: {
            const mustSellSkus = {};
            const mustSellSkusList = action.payload;

            mustSellSkusList.map((mustSell) => {
                mustSellSkus[mustSell.id] = mustSell;
            })

            return {
                ...state,
                mustSells: mustSellSkus,
            }
        }
        case GET_MUST_SELL_SKU: {
            return {
                ...state,
                mustSell: action.payload,
            }
        }

        case GET_MUST_SELL_SKUS_BY_IDS: {
            const mustSellSkus = Object.assign({}, state.mustSells);
            const mustSellSkusList = action.payload;

            mustSellSkusList.map((mustSell) => {
                mustSellSkus[mustSell.id] = mustSell;
            })

            return {
                ...state,
                mustSells: mustSellSkus,
            }
        }

        case UPDATE_MUST_SELL_SKU: {
            const mustSells = Object.assign({}, state.mustSells);
            const updatedMustSellSku = action.payload;

            mustSells[updatedMustSellSku.id] = updatedMustSellSku;

            return {
                ...state,
                mustSells
            }
        }

        case CREATE_MUST_SELL_SKU: {
            const mustSells = Object.assign({}, state.mustSells);
            const newMustSellSku = action.payload;

            mustSells[newMustSellSku.id] = newMustSellSku;

            return {
                ...state,
                mustSells
            }
        }
        case DELETE_MUST_SELL_SKUS: {
            const mustSells = Object.assign({}, state.mustSells);
            const deletedMustSellSkuIds = action.payload;

            deletedMustSellSkuIds.forEach((mustSellSkuId) => {
                delete mustSells[mustSellSkuId];
            })

            return {
                ...state,
                mustSells
            }
        }
        default:
            return state;
    }
};